const JOB_LINKED_FIELDS = {
  title: ['search_title'],
  workOrderName: ['search_workOrderName', 'search_workOrderNameStr'],
  model: ['search_model', 'search_modelStr'],
  frameType: ['search_frameType', 'search_frameTypeStr'],
  brand: ['search_brand', 'search_brandStr'],
  userEnteredPartNumber: ['search_userEnteredPartNumber'],
  createdUserLocationName: ['search_createdUserLocationName'],
  createdUserFullname: ['search_createdUserFullname'],
  customerInfoText: ['search_customerInfoText'],
  projectInfoText: ['search_projectInfoText'],
  documentNumber: ['search_documentNumber'],
  serialNumber: ['search_serialNumber'],
  revision: ['search_revision'],
  sapReference: ['search_sapReference'],
  salesForceNumber: ['search_salesForceNumber'],
  workOrderNumber: ['search_workOrderNumber'],
  executingSite: ['search_executingSite'],
};

export const LINKED_FIELDS = {
  description: ['descriptionDropdown', 'hasDescription'],

  point: [
    'startPoint',
    'firstPoint',
    'secondPoint',
    'thirdPoint',
    'fourthPoint',
  ],
  measurements: ['multipleMeasurements', 'measurementCount'],
  assembly: ['originalAssembly'],
  itemNumber: ['originalItemNumber'],
  partNumber: ['originalPartNumber'],
  partName: ['originalPartName'],
  quantity: ['originalQuantity'],
  ...JOB_LINKED_FIELDS,
};

export const FIELDS_WITHOUT_DISPLAY = ['point'];

export const CUSTOM_FIELD_COMPONENTS = {
  multipleChoices: 'ConflictMultipleChoiceField',
  measurements: 'ConflictMeasurementsField',
  images: 'ConflictImagesField',
  image: 'ConflictImagesField',
  tableData: 'ConflictInstructionTableField',
  tableImg: 'ConflictImagesField',
  checked: 'ConflictInstructionActionField',
  imageReference: 'ConflictImagesField',
  uploadFile: 'ConflictImagesField',
};

export const FIELD_VALUES_OVERWRITE = {
  clk: 'Clock',
  deg: 'Degree',
  negative: '-/-',
  normal: '+/-',
  positive: '+/+',
  in: 'Inches',
  mm: 'Milimeter',
  right: 'Right',
  up: 'Up',
  down: 'Down',
  left: 'Left',
};
